import { render, staticRenderFns } from "./SubmissionFormForReviewGroup.vue?vue&type=template&id=3f463150&scoped=true&"
import script from "./SubmissionFormForReviewGroup.vue?vue&type=script&lang=js&"
export * from "./SubmissionFormForReviewGroup.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionFormForReviewGroup.vue?vue&type=style&index=0&id=3f463150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f463150",
  null
  
)

export default component.exports